"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cover = /*#__PURE__*/function () {
  function Cover(cover) {
    _classCallCheck(this, Cover);
    this.cover = cover;
    this.container = cover.parentNode;
    this.ratio;
    this.load();
  }
  return _createClass(Cover, [{
    key: "load",
    value: function load() {
      var _this = this;
      var src = this.cover.dataset.src;
      var img = new Image();
      img.addEventListener('load', function () {
        _this.cover.src = src;
        _this.listen();
      });
      img.src = src;
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this2 = this;
      this.ratio = this.cover.width / this.cover.height;
      setTimeout(function () {
        _this2.resize();
      }, 0);
      this.cover.classList.add('is-loaded');
      window.addEventListener('resize', function () {
        _this2.resize();
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      var ratio = this.container.clientWidth / this.container.clientHeight;
      if (ratio >= this.ratio) {
        this.cover.style.height = 'auto';
        this.cover.style.width = '100%';
      } else {
        this.cover.style.width = 'auto';
        this.cover.style.height = '100%';
      }
    }
  }]);
}();
document.addEventListener('DOMContentLoaded', function () {
  var covers = _toConsumableArray(document.getElementsByClassName('js-cover-image'));
  if (covers.length) {
    covers.forEach(function (c) {
      new Cover(c);
    });
  }
});